const C = require("../constants");

const selectProvider = (data) => {
    return {
        type: C.PROVIDER_SELECT,
        data
    }
};

export {selectProvider};


// WEBPACK FOOTER //
// ./src/actions/ProviderSelectAction.js